import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appSpinnerColor]',
    standalone: true
})
export class SpinnerColorDirective implements AfterViewInit {


  @Input('appSpinnerColor') color: string = '#000000';

  constructor(private readonly elem: ElementRef) { }

  ngAfterViewInit(): void {
    const element = this.elem.nativeElement;
    const circle = element.querySelector("circle");
    circle.style.stroke = this.color;

  }

}
